// extracted by mini-css-extract-plugin
export var avatar = "_jy-3";
export var avatarContainer = "_jy-2";
export var avatarSpacer = "_jy-5";
export var avatarSpacerContainer = "_jy-4";
export var avatarStackContainer = "_jy-1";
export var bubble = "_jy-0";
export var remainderBubble = "_jy-6";